module.exports = __webpack_public_path__ + "static/media/wedding.21a51d37.jpeg";